import { ColouredLogo, Logo } from '../../icons'

export const AuthLayout: React.FC = ({ children }) => {
	return (
		<section className='container'>
			<div className='login-layout'>
				<section className='left-section'>
					<Logo />
					<section className='content'>
						<p>
							Bu alanda oluşturacağımız videodan iyi bir görsel ya da direk
							videoyu bu alana koymayı düşünüyorum.
						</p>
						<p>Copyright © 2021 - All rights reserved.</p>
					</section>
				</section>
				<section className='right-section'>
					<section className='coloured-logo-section'>
						<ColouredLogo />
					</section>
					<section className='component'>{children}</section>
				</section>
			</div>
		</section>
	)
}
